import styled from 'styled-components';

export const Burger = styled.div`
position: absolute;
top: 64px;
right: 64px;
z-index: 4;
width: 60px;
height: 60px;
display: flex;
align-items: center;
justify-content: center;
.burger__path {
    stroke-dasharray: 19px 100px;
    stroke-dashoffset: 0;
    transition: .75s cubic-bezier(.55, 0, .1, 1);
}

&:hover {
    .burger__path {
        stroke-dashoffset: -39px;
    }

    .burger__path--2 {
        transition-delay: .1s;
    }
}
`;